/**
 * Payment Service
 * Handles payment processing API calls
 */

import apiClient from '@/api/client';
import { API_ENDPOINTS } from '@/config/api.config';
import type {
  PreparePaymentRequest,
  PreparePaymentResponse,
  TransactionResultResponse,
} from '@/types/api.types';

/**
 * Prepare payment for Cybersource
 */
export const preparePayment = async (
  amount: number
): Promise<PreparePaymentResponse> => {
  const request: PreparePaymentRequest = { amount };

  const response = await apiClient.post<PreparePaymentResponse>(
    API_ENDPOINTS.PAYMENTS.PREPARE,
    request
  );

  return response.data;
};

/**
 * Get transaction result by token
 */
export const getTransactionResult = async (
  token: string,
  signal?: AbortSignal
): Promise<TransactionResultResponse> => {
  const response = await apiClient.get<TransactionResultResponse>(
    API_ENDPOINTS.PAYMENTS.RESULT(token),
    { signal }
  );

  return response.data;
};
